// src/components/Hero.js
import React from 'react';
import './Hero.css';

function Hero() {
  return (
    <section id="inicio" className="hero-section">
      <div className="container">
        <h1 className="hero-title">Cultivo Sostenible de Olivos, Pecanes y Almendros</h1>
        <p className="hero-text">
          En OLPEAL nos dedicamos a la producción de alta calidad de aceitunas, nueces de pecan y almendras, 
          utilizando técnicas agrícolas sostenibles que respetan el medio ambiente y garantizan la excelencia en cada cosecha.
        </p>
      </div>
    </section>
  );
}

export default Hero;